import React, { useEffect, useState } from 'react';
import { View, TextInput, StyleSheet , Text, BackHandler} from 'react-native';
import { FONT_STYLE } from '../../dataSchema/const';

const InputPhoneNumber = ({handleText, defaultAnswer = null}) => {
  const [text, setText] = useState('');
  const [wordCount, setWordCount] = useState(0);
  const [isFocus, setFocus]= useState(false);
  const [isValid, setValid]= useState(true);

  const isValidNumber = (text) => {
      const textRegex = /^\d+$/;
      return textRegex.test(text);
    };

  const onChangeText=(text: string)=>{
    setText(text);
  }

  const sanitizePhone=(phone: string)=> {
    if (!phone) return "";
    if (phone.startsWith("84")) {
      let nums = phone.substring(2);
      if (nums.length === 9) return `84${nums}`;
      if (nums.length > 9 && nums.startsWith("0")) {
        nums = nums.substring(1, 10);
        return `84${nums}`;
      }
      if (nums.length > 9) {
        nums = nums.substring(0, 10);
        return `84${nums}`;
      }

      return phone;
    }

    if (phone.length === 9) return `84${phone}`;
    if (phone.length > 9 && phone.startsWith("0")) {
      let nums = phone.substring(1, 10);
      return `84${nums}`;
    }

    if (phone.length > 9) {
      let nums = phone.substring(0, 9);
      return `84${nums}`;
    }

    return phone;
  }


  const onHandleInputNumber=()=>{
    if(isValidNumber(text))
      {
        if(handleText){
          let phone = sanitizePhone(text)
          setText(phone)
          handleText(phone);
          setValid(true);
        }
      }else{
        onClearText();
        setValid(false);
      }
  }

  const onClearText = () => {
    setText('');
  };

  const onFocusInput=(wordCount)=>{
    setWordCount(wordCount);
  }

  useEffect(()=>{
    if(defaultAnswer && defaultAnswer.values){
      onChangeText(defaultAnswer.values[0])
    }
  },[])

  return (
    <View style={styles.inputWrapper}>
      {
        isValid ? null :(
        <Text style={styles.errorText}>
          {`Nhập số không hợp lệ`}
        </Text>
        )
      }
      <TextInput style={isFocus?styles.focusTextField: styles.textField}
        value={text}
        onChangeText={(text)=>{
          onChangeText(text)
          onFocusInput(text.length);
        }}
        onFocus={()=>{setFocus(true)}}
        onBlur={()=>{
            onHandleInputNumber();
            setFocus(false);
        }}
        autoFocus={false}
        placeholder='Ví dụ: 84123456789'
        placeholderTextColor={'#666666'}
        maxLength={11}
      />
      {
        isFocus?
        (
        <Text style={styles.count}>{`Ký tự: ${wordCount}/11`}</Text>
        )
        : null
      }
    </View>
  );
};


const styles = StyleSheet.create({
    inputWrapper:{
      backgroundColor:'#FFFFFF',
      height:100,
      alignContent:'center',
      justifyContent:'center'
    },
    textField:{
      padding:10,
      marginTop:5,
      height:60,
      borderRadius: 10,
      borderColor:'#444444',
      borderWidth:1,
      textAlignVertical: 'center',
      fontFamily:FONT_STYLE.MEDIUM,
      fontSize:14
    },
    focusTextField:{
        padding:10,
        marginTop:5,
        height:100,
        borderRadius: 10,
        borderColor:'#444444',
        borderWidth:1,
        textAlignVertical: 'center',
        fontFamily:FONT_STYLE.MEDIUM,
        fontSize:14
      },
    count:{
      position:'absolute',
      textAlign:'right',
      paddingRight:10,
      fontSize:14,
      color:'#444444',
      fontFamily:FONT_STYLE.MEDIUM,
      width:'100%',
      paddingTop: 70,
    },    
    errorText:{
      padding: 5,
      fontSize:14,
      fontFamily: FONT_STYLE.MEDIUM,
      color:'red'
    }
    
})
export default InputPhoneNumber;
